import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';


// generated by Fragment Matcher plugin
import introspectionResult from './introspection-result';
const fragmentMatcher = new IntrospectionFragmentMatcher({
    introspectionQueryResultData: introspectionResult,
});


export * from './resolvers';
export * from './schemas';
export * from './defaults';
export  * from './id-generation';
export { fragmentMatcher };
